import React from 'react';
import style from './style.module.scss';

import login1 from '../../assets/login1.png'
import login2 from '../../assets/login2.png'
import login3 from '../../assets/login3.png'
import login4 from '../../assets/login4.png'
import login5 from '../../assets/login5.png'
import login6 from '../../assets/login6.png'
import login7 from '../../assets/login7.png'
import login8 from '../../assets/login8.png'
import login9 from '../../assets/login9.png'

const Background = () => (
  <div className={style.bgWrapper}>
    <img src={login1} className={style.item1} alt="Imagem Login" />
    <img src={login2} className={style.item2} alt="Imagem Login" />
    <img src={login3} className={style.item3} alt="Imagem Login" />
    <img src={login4} className={style.item4} alt="Imagem Login" />
    <img src={login5} className={style.item5} alt="Imagem Login" />
    <img src={login6} className={style.item6} alt="Imagem Login" />
    <img src={login7} className={style.item7} alt="Imagem Login" />
    <img src={login8} className={style.item8} alt="Imagem Login" />
    <img src={login9} className={style.item9} alt="Imagem Login" />
  </div>
)

export default Background 